<div class="dialog-content" [class]="data.classDialog">
  <div class="topSec">
    <div class="header">
      <div class="cabecera-accion">
        <button
          (click)="onClose()"
          aria-label="Cancelar"
          class="cancelar"
        ></button>
      </div>
      <!-- <div class="icon-header">
        <img [src]="dialogImage" [alt]="data.classDialog" />
      </div> -->
    </div>

    <div class="contenidoInfo">
      <h2 class="dialog-title">{{ data.title }}</h2>
      <p class="dialog-description">{{ data.description }}</p>
    </div>
  </div>

  <div
    class="dialog-actions"
    *ngIf="data.classDialog !== 'leer' && data.classDialog !== 'enviar'"
  >
    <button
      mat-raised-button
      color="warn"
      (click)="onConfirm()"
      class="confirm-button"
    >
      {{ data.confirmText || "Confirmar" }}
    </button>

    @if(data.showCancel){
    <div class="separador"></div>
    <button mat-stroked-button (click)="onCancel()" class="cancel-button">
      {{ data.cancelText || "Cancelar" }}
    </button>
    }
  </div>

  <div
    class="dialog-actions"
    *ngIf="data.classDialog === 'leer' || data.classDialog === 'enviar'"
  >
    <button mat-stroked-button (click)="onCancel()" class="cerrar-button">
      Cerrar
    </button>
  </div>
</div>
